import { mapUnboundedSizing } from '../../../unboundedProps.js';

var sizingStyleMapper = {
  height: function height(value, _) {
    return mapUnboundedSizing('height', value);
  },
  minHeight: function minHeight(value, _) {
    return mapUnboundedSizing('minHeight', value);
  },
  maxHeight: function maxHeight(value, _) {
    return mapUnboundedSizing('maxHeight', value);
  },
  width: function width(value, _) {
    return mapUnboundedSizing('width', value);
  },
  minWidth: function minWidth(value, _) {
    return mapUnboundedSizing('minWidth', value);
  },
  maxWidth: function maxWidth(value, _) {
    return mapUnboundedSizing('maxWidth', value);
  }
};

export { sizingStyleMapper };
//# sourceMappingURL=sizing.js.map
